<div class="p-4 bottom80">
    <h2 class="fs28 gray-dark inter bold mb-5" translate>aziende.aziende</h2>
    <div id="companies-list" class="companies-list">
        <app-aziende></app-aziende>        
    </div>
</div>